module.exports = __webpack_public_path__ + "static/media/DA_architects_logo.6f78aa36.svg";